import InventoryReconciliation from "models/inventory-reconciliation";
import { formaTimeToAllSecond } from 'common/js/util'
export default {
  data() {
    return {
      // 选中的进仓单
      activeStorageCode: '',
      // 进出单所有数据
      storageCodeList: [],
      // 表格数据
      storageTableData: [],
      storageTableTitle: [
        {width: '220', prop: 'settlementDate', label: '结算日期' },
        {width: '', prop: 'billHeadName', label: '抬头名称/抬头编码' },
        {width: '', prop: 'agentBusinessVal', label: '代收代付' },
        {width: '', prop: 'currencyVal', label: '币制'},
        {width: '', prop: 'amount', label: '金额' },
        {width: '', prop: 'invoiceId', label: '发票编号' }
      ],


      historicalRecordsDialog: false,
      historicalRecordsList: [],
      historicalRecordsTitle: [
        { showOverflowTooltip: false, prop: 'createTime', label: '时间', width: '120' },
        { showOverflowTooltip: false, prop: 'operator', label: '操作员', width: '' },
        { showOverflowTooltip: false, prop: 'before', label: '修改前金额', width: '' },
        { showOverflowTooltip: false, prop: 'after', label: '修改后金额', width: '' }
      ]
    }
  },
  created() {
  },
  methods: {
    // 单击出仓单的数据
    onActiveStorageCode(row) {
      this.activeStorageCode = row.code
      this.storageTableData = row.subjectList
    },

    // 取消存储费金额修改
    cancelStorageWarehouseCodeAmount(row) {
      row.isMod = false
      row.amount = row.amountCopy
    },

    // 开启存储费金额修改
    modStorageWarehouseCodeAmount(row) {
      row.isMod = true
    },

    saveStorageWarehouseCodeAmount(row) {
      let data = {};
      data.id = row.id;
      data.price = row.amount ? Number(row.amount) : 0;
      InventoryReconciliation.postModStorageAmount(data, row.id).then(res => {
        if (res.success) {
          row.isMod = false
          row.amountCopy = row.amount
          this.$message.success('保存成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 查看编辑记录
    lookModRecords(row) {
      let id = row.id
      InventoryReconciliation
        .postStorageModRecordsList(id)
        .then(res => {
          if (res.success) {
            let arr = []
            res.result.map(i => {
              let obj = {}
              obj.createTime = formaTimeToAllSecond(i.createTime)
              obj.operator = i.operator
              obj.before = i.beforeAmount
              obj.after = i.afterAmount
              obj.remarks = i.remark
              arr.push(obj)
            })
            this.historicalRecordsList = arr;
            this.historicalRecordsDialog = true
          } else {
            this.$message.error(res.message);
          }
        });
    },


    handleClose() {
      this.historicalRecordsDialog = false
    }
  }
}